import BaseService from 'services/BaseService';

export default class TagService extends BaseService {
	_type = 'tag';
	_typeKey = 'tag_type';
}
